import * as R from 'ramda'
import * as S from 'sanctuary'
import { nullableToMaybe } from 'libs/maybe'

export const localizedItem = (item, formatMessage) =>
  S.fromMaybe(item.title)(
    S.map(id => formatMessage({ id }))(
      nullableToMaybe(R.view(R.lensProp('localizedId'), item)),
    ),
  )
